import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mockGalleryImages } from '../mockData';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const GallerySection = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % mockGalleryImages.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + mockGalleryImages.length) % mockGalleryImages.length);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#003366] mb-4">
            {t('gallery.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('gallery.subtitle')}
          </p>
        </div>

        {/* Main Image Slider */}
        <div className="relative max-w-5xl mx-auto">
          <div className="relative h-[500px] rounded-lg overflow-hidden shadow-2xl bg-gray-100">
            <img
              src={mockGalleryImages[currentIndex].url}
              alt={t(`gallery.images.${mockGalleryImages[currentIndex].alt}`)}
              className="w-full h-full object-contain"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <p className="text-xl font-semibold">{t(`gallery.images.${mockGalleryImages[currentIndex].alt}`)}</p>
              <p className="text-sm text-gray-200">
                {currentIndex + 1} / {mockGalleryImages.length}
              </p>
            </div>
          </div>

          {/* Navigation Buttons */}
          <Button
            onClick={prevImage}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-gray-900 rounded-full w-12 h-12 p-0"
          >
            <ChevronLeft className="w-6 h-6" />
          </Button>
          <Button
            onClick={nextImage}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white text-gray-900 rounded-full w-12 h-12 p-0"
          >
            <ChevronRight className="w-6 h-6" />
          </Button>
        </div>

        {/* Thumbnail Grid */}
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4 mt-8 max-w-5xl mx-auto">
          {mockGalleryImages.map((image, index) => (
            <button
              key={image.id}
              onClick={() => setCurrentIndex(index)}
              className={`relative h-24 rounded-lg overflow-hidden border-2 transition-all ${
                currentIndex === index
                  ? 'border-[#0052CC] shadow-lg'
                  : 'border-transparent hover:border-[#2684FF]'
              }`}
            >
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;